export const getFooterDetails = () => {
    const baseURL: string = process.env.REACT_APP_API_URL as string;
    return fetch(`${baseURL}api/v1/login_info`, {
      method: "get",
    }).then((data) => data.json());
  };